import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import uuid from 'uuid';
import produce from 'immer';
import { selectWidget } from '../selectors/widgetsSelector';
import Utils from '../../../../../../utils';

function contentReducer(state, action) {
  switch (action.type) {
    case 'insert_chart':
      return insertChart(state, action.payload);

    case 'edit_chart':
      return editChart(state, action.payload);

    case 'insert_table':
      return insertTable(state, action.payload);

    case 'edit_table':
      return editTable(state, action.payload);

    case 'insert_gauge':
      return insertGauge(state, action.payload);

    case 'edit_gauge':
      return editGauge(state, action.payload);

    case 'remove_widget':
      return removeWidget(state, action.payload);

    case 'change_widget_property':
      return changeWidgetProperty(state, action.payload);

    case 'clear_styles':
      return clearStyles(state, action.payload);

    case 'change_dimension':
      return changeDimension(state, action.payload);

    default:
      return state;
  }
}

var defaultUiFilter = {
  uiFilter: [{
    rule: 'filter(global)'
  }, {
    rule: 'filter(page)'
  }]
};

var insertChart = function insertChart(state, chart) {
  var cube = {
    id: uuid(),
    axes: [_objectSpread({}, chart.category, {
      id: uuid()
    })],
    measures: chart.series.map(function (series) {
      return _objectSpread({}, series.value, {
        id: uuid()
      });
    })
  };
  var newLayout = createLayout();
  var chartWidget = {
    elementName: chart.type === 'areaChart' ? 'lineChart' : chart.type,
    id: chart.id,
    source: cube.id,
    areaId: newLayout.gridLayout.cellLayout.id,
    action: 'marking(Blue)',
    borderStyle: 'none',
    caption: {
      textAlign: 'center'
    },
    legend: {},
    category: {
      source: cube.axes[0].id
    },
    series: chart.series.map(function (series, seriesIndex) {
      // value is converted into a source id
      var value = series.value,
          rest = _objectWithoutProperties(series, ["value"]);

      var newSeries = _objectSpread({}, rest, {
        source: cube.measures[seriesIndex].id
      });

      if (chart.type === 'areaChart') newSeries.fillAlpha = '1'; // use the same color for line until implemented

      if (newSeries.fillColor) newSeries.lineColor = newSeries.fillColor;
      return newSeries;
    }),
    categoryAxis: {
      axisCaption: {}
    },
    valuesAxis: {
      axisCaption: {}
    },
    scrollBar: {
      visibility: 'Hidden'
    },
    chartGridline: {
      horizontalGridline: {},
      verticalGridline: {}
    },
    uiFilter: defaultUiFilter
  };
  return produce(state, function (draft) {
    draft.dashboard.cubes.push(cube);
    draft.dashboard.dashboardLayout.pageLayouts.push(newLayout);
    var pageIndex = draft.dashboard.pages.length + 1;
    var newPage = createWidgetPage(pageIndex, chartWidget, newLayout);
    draft.dashboard.pages.push(newPage);
  });
};

var editChart = function editChart(state, chart) {
  return produce(state, function (draft) {
    var widget = selectWidget(draft, chart.id);
    var cube = draft.dashboard.cubes.find(function (cube) {
      return cube.id === widget.source;
    });
    cube.axes = [_objectSpread({}, chart.category, {
      id: uuid()
    })];
    cube.measures = chart.series.map(function (series) {
      return _objectSpread({}, series.value, {
        id: uuid()
      });
    });
    widget.category = {
      source: cube.axes[0].id
    };
    widget.series = chart.series.map(function (series, seriesIndex) {
      // value is converted into a source id
      var value = series.value,
          rest = _objectWithoutProperties(series, ["value"]);

      var newSeries = _objectSpread({}, rest, {
        source: cube.measures[seriesIndex].id
      });

      if (chart.type === 'areaChart') newSeries.fillAlpha = '1'; // use the same color for line until implemented

      if (newSeries.fillColor) newSeries.lineColor = newSeries.fillColor;
      return newSeries;
    });
  });
};

var insertTable = function insertTable(state, table) {
  var cube = {
    id: uuid(),
    axes: table.columns.filter(function (column) {
      return column.value.expression === undefined;
    }).map(function (axisColumn) {
      return _objectSpread({}, axisColumn.value, {
        id: axisColumn.id
      });
    }),
    measures: table.columns.filter(function (column) {
      return column.value.expression !== undefined;
    }).map(function (measureColumn) {
      return _objectSpread({}, measureColumn.value, {
        id: measureColumn.id
      });
    })
  };
  var newLayout = createLayout();
  var tableWidget = {
    elementName: 'table',
    id: table.id,
    source: cube.id,
    areaId: newLayout.gridLayout.cellLayout.id,
    action: 'marking(Blue)',
    caption: {
      textAlign: 'center'
    },
    header: {},
    columns: table.columns.map(function (column) {
      return {
        title: column.title,
        source: column.id,
        width: 'proportional-column-width(1)',
        format: column.format,
        align: column.align
      };
    }),
    uiFilter: defaultUiFilter
  };
  return produce(state, function (draft) {
    draft.dashboard.cubes.push(cube);
    draft.dashboard.dashboardLayout.pageLayouts.push(newLayout);
    var pageIndex = draft.dashboard.pages.length + 1;
    var newPage = createWidgetPage(pageIndex, tableWidget, newLayout);
    draft.dashboard.pages.push(newPage);
  });
};

var editTable = function editTable(state, table) {
  return produce(state, function (draft) {
    var widget = selectWidget(draft, table.id);
    var cube = draft.dashboard.cubes.find(function (cube) {
      return cube.id === widget.source;
    });
    cube.axes = table.columns.filter(function (column) {
      return column.value.expression === undefined;
    }).map(function (axisColumn) {
      return _objectSpread({}, axisColumn.value, {
        id: axisColumn.id
      });
    });
    cube.measures = table.columns.filter(function (column) {
      return column.value.expression !== undefined;
    }).map(function (measureColumn) {
      return _objectSpread({}, measureColumn.value, {
        id: measureColumn.id
      });
    });
    widget.columns = table.columns.map(function (column) {
      return {
        title: column.title,
        source: column.id,
        width: 'proportional-column-width(1)',
        format: column.format,
        align: column.align
      };
    });
  });
};

var insertGauge = function insertGauge(state, gauge) {
  var cube = {
    id: uuid(),
    axes: [],
    measures: [_objectSpread({}, gauge.value, {
      id: uuid()
    })]
  };
  var newLayout = createLayout();
  var gaugeWidget = {
    elementName: 'circularGauge',
    id: gauge.id,
    areaId: newLayout.gridLayout.cellLayout.id,
    source: cube.id,
    value: cube.measures[0].id,
    startValue: gauge.startValue,
    endValue: gauge.endValue,
    majorTickCount: gauge.majorTickCount,
    caption: {
      textAlign: 'center'
    },
    gaugeSegment: {
      startValue: gauge.startValue,
      endValue: gauge.endValue,
      color: 'rgb(128,128,128)'
    },
    uiFilter: defaultUiFilter
  };
  return produce(state, function (draft) {
    draft.dashboard.cubes.push(cube);
    draft.dashboard.dashboardLayout.pageLayouts.push(newLayout);
    var pageIndex = draft.dashboard.pages.length + 1;
    var newPage = createWidgetPage(pageIndex, gaugeWidget, newLayout);
    draft.dashboard.pages.push(newPage);
  });
};

var editGauge = function editGauge(state, gauge) {
  return produce(state, function (draft) {
    var widget = selectWidget(draft, gauge.id);
    var cube = draft.dashboard.cubes.find(function (cube) {
      return cube.id === widget.source;
    });
    cube.measures = [_objectSpread({}, gauge.value, {
      id: uuid()
    })];
    widget.value = cube.measures[0].id;
    widget.startValue = gauge.startValue;
    widget.endValue = gauge.endValue;
    widget.majorTickCount = gauge.majorTickCount;
    widget.gaugeSegment = {
      startValue: gauge.startValue,
      endValue: gauge.endValue,
      color: 'rgb(128,128,128)'
    };
  });
};

var removeWidget = function removeWidget(state, widgetId) {
  return produce(state, function (draft) {
    for (var i = 0; i < draft.dashboard.pages.length; i++) {
      var widgetIndex = draft.dashboard.pages[i].widgets.findIndex(function (widget) {
        return widget.id === widgetId;
      });

      if (widgetIndex !== -1) {
        var _ret = function () {
          var widgetCubeId = draft.dashboard.pages[i].widgets[widgetIndex].source;
          var cubeIndex = draft.dashboard.cubes.findIndex(function (cube) {
            return cube.id === widgetCubeId;
          });
          draft.dashboard.cubes.splice(cubeIndex, 1);
          draft.dashboard.pages[i].widgets.splice(widgetIndex, 1);
          return "break";
        }();

        if (_ret === "break") break;
      }
    }
  });
};

var changeWidgetProperty = function changeWidgetProperty(state, options) {
  return produce(state, function (draft) {
    var draftWidget = selectWidget(draft, options.widgetId);
    var sourcePropertyValue = options.sourcePropertyName ? draftWidget[options.sourcePropertyName] : draftWidget;

    if (Array.isArray(sourcePropertyValue)) {
      sourcePropertyValue.forEach(function (element) {
        if (options.value) element[options.propertyName] = options.value;else delete element[options.propertyName];
      });
    } else {
      if (options.value) sourcePropertyValue[options.propertyName] = options.value;else delete sourcePropertyValue[options.propertyName];
    }
  });
};

var clearStyles = function clearStyles(state, _ref) {
  var widgetId = _ref.widgetId,
      sourcePropertyName = _ref.sourcePropertyName;
  return produce(state, function (draft) {
    var draftWidget = selectWidget(draft, widgetId);
    var sourcePropertyValue = sourcePropertyName ? draftWidget[sourcePropertyName] : draftWidget;

    for (var key in sourcePropertyValue) {
      if (isStyleProperty(key)) delete sourcePropertyValue[key];
    }
  });
};

var isStyleProperty = function isStyleProperty(propertyName) {
  switch (propertyName) {
    case 'fontFamily':
    case 'fontSize':
    case 'backgroundColor':
    case 'color':
    case 'fontWeight':
    case 'fontStyle':
      return true;

    default:
      return false;
  }
};

var changeDimension = function changeDimension(state, _ref2) {
  var cubeId = _ref2.cubeId,
      dimensionId = _ref2.dimensionId,
      dimension = _ref2.dimension;
  return produce(state, function (draft) {
    var changedCube = draft.dashboard.cubes.find(function (cube) {
      return cube.id === cubeId;
    });
    var changedAxis = changedCube.axes.find(function (axis) {
      return axis.id === dimensionId;
    });

    if (changedAxis) {
      changedCube.axes.splice(changedCube.axes.indexOf(changedAxis), 1, dimension);
    } else {
      var changedMeasure = changedCube.measures.find(function (measure) {
        return measure.id === dimensionId;
      });
      changedCube.measures.splice(changedCube.measures.indexOf(changedMeasure), 1, dimension);
    }
  });
};

var createLayout = function createLayout() {
  return {
    name: uuid(),
    gridLayout: {
      spacing: '10',
      columnLayout: {
        width: '1200',
        fixed: 'false'
      },
      rowLayout: {
        height: '800',
        fixed: 'false'
      },
      cellLayout: {
        id: uuid()
      }
    }
  };
};

var createWidgetPage = function createWidgetPage(pageIndex, widget, layout) {
  return {
    layoutName: layout.name,
    title: "".concat(pageIndex, ". ").concat(Utils.formatting.camelCaseToWords(widget.elementName)),
    widgets: [widget]
  };
};

export default contentReducer;